<template>
  <div class="container" v-loading="loading">
    <div class="seach-header">
      <el-input :rows="4" v-model="RoomNoAndName" @keydown.enter.native="getList" clearable @clear="getList" size="medium" placeholder="请输入(姓名、房号)"></el-input>
      <div class="add" @click="getList">查找</div>
      <div class="add" @click="editLeaveHospital({})">新增</div>
    </div>
    <div class="time-header">
      <!-- <div class="filter" @click="allFilter">筛选</div> -->
      <el-date-picker v-model="Begin" size="medium" :clearable="false" type="date" value-format="yyyy-MM-dd" @change="dateChange" placeholder="选择日期"> </el-date-picker>
      <span class="line"> — </span>
      <el-date-picker v-model="End" size="medium" :clearable="false" type="date" value-format="yyyy-MM-dd" @change="dateChange" placeholder="选择日期"> </el-date-picker>
    </div>

    <div id="lv-list" v-if="list.length" v-loading="loading" class="lp-men-list">
      <div v-for="(item, index) in list" :key="index" :id="'lv-list' + index" class="lp-list-item">
        <div class="lp-item-info">
          <img v-if="item.Gender === 'M'" :src="require('@/assets/imgs/boy.png').default" alt="" />
          <img v-else :src="require('@/assets/imgs/girl.png').default" alt="" />
          <div>
            <div class="info-base">
              <div class="name">{{ item.Name }}</div>
              <img class="icon" :src="require('@/assets/imgs/room.png').default" alt="" />
              <div class="room">{{ item.Room }}</div>
            </div>
            <div class="time">提交时间：{{ item.Cdate }}</div>
          </div>
          <div v-if="item.Status === '暂离院中'" class="item-status status1">暂离院中</div>
          <div v-if="item.Status === '审批中'" class="item-status status2">审批中</div>
          <div v-if="item.Status === '回院'" class="item-status status3">回院</div>
          <div v-if="item.Status === '草稿'" class="item-status status4">草稿</div>
          <div v-if="item.Status === '已取消'" class="item-status status4">已取消</div>
          <div v-if="item.Status === '审批不通过'" class="item-status status5">审批不通过</div>
        </div>

        <div class="leave-status" @click="shrink(item)">
          暂离院
          <div class="arrow-down" v-if="item.flag"></div>
          <div class="arrow-up" v-else></div>
        </div>
        <!-- 收缩盒子 -->
        <div :style="{ height: item.flag ? '2.1rem' : 'fit-content', overflow: 'hidden', position: 'relative' }">
          <div class="leave-content leave-content-dotted">
            <div class="leave-item">
              <span class="leave-name">暂离开始时间</span>
              <span class="leave-value">{{ item.BeginDate || '--' }}</span>
            </div>
            <div class="leave-item">
              <span class="leave-name">预计回院时间</span>
              <span class="leave-value">{{ item.EndDate || '--' }}</span>
            </div>
            <div class="leave-item">
              <span class="leave-name">暂离事由</span>
              <span class="leave-value">{{ item.TypeName || '--' }}</span>
            </div>
            <div class="leave-item">
              <span class="leave-name">家属信息</span>
              <span class="leave-value">{{ item.ContactPerson || '--' }}</span>
            </div>
            <div class="leave-item">
              <span class="leave-name">暂离备注</span>
              <span class="leave-value">{{ item.Remark || '--' }}</span>
            </div>
          </div>
          <div class="leave-status">回院</div>
          <div class="leave-content" style="padding-bottom: 0">
            <div class="leave-item">
              <span class="leave-name">回院时间</span>
              <span class="leave-value">{{ item.cendDate || '--' }}</span>
            </div>
            <div class="leave-item">
              <span class="leave-name">备注</span>
              <span class="leave-value">{{ item.EndRemark || '--' }}</span>
            </div>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="leave-status-btn">
          <div v-if="['暂离院中'].includes(item.Status)" class="lp-btn1" @click="backHospital(item)">回院</div>
          <div v-if="['草稿'].includes(item.Status)" class="lp-btn1" @click="onSubmitApply(item)">提交</div>
          <div v-if="['草稿'].includes(item.Status)" class="lp-btn2" @click="editLeaveHospital(item)">编辑</div>
          <div v-if="['草稿', '已取消', '审批不通过'].includes(item.Status)" class="lp-btn2" @click="deleteRecord(item)">删除</div>
        </div>
      </div>
    </div>
    <div class="lp-empty" v-if="!list.length && !loading">暂无数据</div>
    <div>
      <el-pagination
        background
        class="pagination"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100, 150]"
        :page-size="pagesize"
        :pager-count="5"
        layout="total,  prev, pager, next"
        :total="userList.length"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 回院 -->
    <el-dialog title="" top="30vh" :visible.sync="dialogVisible" width="90%" :before-close="close">
      <div>
        <el-form class="form" :model="form" ref="form" :rules="rules" label-width="80px" :inline="false" size="normal">
          <el-form-item label="回院时间">
            <el-date-picker type="datetime" size="small" placeholder="选择日期" v-model="form.cendDate" style="width: 100%" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" :rows="4" v-model="form.EndRemark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" v-loading="loading1" @click="onSubmit1">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { intitime } from '@/tool/index.js'
export default {
  data() {
    return {
      dialogVisible: false,
      value1: '',
      loading: false,
      loading1: false,
      RoomNoAndName: '',
      Begin: '',
      End: '',
      userList: [],
      pagesize: 10,
      currentPage: 1,
      form: {},
      rules: {
        cendDate: [{ required: true, message: '请选择时间', trigger: 'change' }]
      }
    }
  },
  computed: {
    // 列表数据
    list() {
      const listData = this.userList
      return listData.slice((this.currentPage - 1) * this.pagesize, (this.currentPage - 1) * this.pagesize + this.pagesize)
    }
  },

  created() {
    const [currentDate, previousMonthDate] = this.getPreviousMonthDates()
    this.Begin = previousMonthDate
    this.End = currentDate
    this.getList()
  },
  methods: {
    allFilter() {},

    // 获取列表
    getList() {
      const data = {
        RoomNoAndName: this.RoomNoAndName,
        Begin: this.Begin,
        End: this.End
      }
      this.currentPage = 1
      this.loading = true
      this.$axios.post('/pad/TemporarySelect', data).then(
        (res) => {
          this.loading = false
          res.data.obj.forEach((val) => {
            val.Cdate = val.Cdate && intitime(val.Cdate, 'yyyy-MM-dd HH:mm')
            val.BeginDate = val.BeginDate && intitime(val.BeginDate, 'yyyy-MM-dd HH:mm')
            val.EndDate = val.EndDate && intitime(val.EndDate, 'yyyy-MM-dd HH:mm')
            val.cendDate = val.cendDate && intitime(val.cendDate, 'yyyy-MM-dd HH:mm')
            val.flag = true
          })
          this.userList = res.data.obj
        },
        () => {
          this.loading = false
        }
      )
    },

    // 时间变化
    dateChange(val) {
      const time1 = this.Begin
      const time2 = this.End
      if (new Date(time1).getTime() > new Date(time2).getTime()) {
        this.Begin = time2
        this.End = time1
      }
      this.getList()
    },

    // 编辑
    editLeaveHospital(val) {
      this.$router.push({ name: 'addLeave', params: val })
    },

    // 打开回院
    backHospital(val) {
      this.dialogVisible = true
      this.form = { ...val }
    },

    // 提交回院
    onSubmit1() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading1 = true
          this.$axios.post('pad/TemporaryReturn', { ...this.form, EndCreator: this.$store.state.user.UserName }).then(
            (res) => {
              this.loading1 = false
              this.$message.success({
                message: '处理成功',
                offset: 100
              })
              this.getList()
              this.dialogVisible = false
            },
            () => {
              this.loading1 = false
            }
          )
        }
      })
    },

    // 关闭回院
    close() {
      this.dialogVisible = false
      this.form = {}
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },

    // 提交申请
    onSubmitApply(val) {
      this.$confirm('您正在提交暂离院申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/pad/TemporaryTJAudit', { ...val, Creator: this.$store.state.user.UserName }).then((res) => {
          this.getList()
          this.$message.success({
            message: '提交成功',
            offset: 100
          })
        })
      })
    },

    // 删除记录
    deleteRecord(val) {
      this.$confirm('是否删除当前记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/pad/TemporaryDelete', { ...val, Creator: this.$store.state.user.UserName }).then((res) => {
          this.getList()
          this.$message.success({
            message: '删除成功',
            offset: 100
          })
        })
      })
    },

    // 收缩展开
    shrink(val) {
      val.flag = !val.flag
    },

    getPreviousMonthDates() {
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()
      const currentMonth = currentDate.getMonth() + 1 // 月份从0开始，所以要加1
      const currentDay = currentDate.getDate()

      // 获取当前日期的前一个月
      const previousMonthDate = new Date(currentYear, currentMonth - 1, currentDay)
      previousMonthDate.setMonth(previousMonthDate.getMonth() - 1)

      // 格式化日期
      const formatDate = (date) => {
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        return `${year}-${month}-${day}`
      }

      const currentDateStr = formatDate(currentDate)
      const previousMonthDateStr = formatDate(previousMonthDate)

      return [currentDateStr, previousMonthDateStr]
    },

    // 下一页
    handleCurrentChange(val) {
      console.log(val)
      this.currentPage = val
      this.$nextTick(() => {
        document.getElementById('lv-list0').scrollIntoView()
      })
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.filter,
.add {
  flex-shrink: 0;
  padding: 9px 18px;
  margin-left: 10px;
  border-radius: 4px;
  background: #029fd1;
  font-size: 14px;
  color: #fff;
}

.lp-men-list {
  flex: 1;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  margin-top: 12px;
  overflow-y: auto;
}

.lp-list-item {
  width: 100%;
  height: fit-content;
  padding: 12px 8px;
  margin-bottom: 12px;
  background: #fff;
  box-sizing: border-box;
}

.lp-item-info {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.lp-item-info img {
  width: 42px;
  height: 42px;
  margin-right: 6px;
}

.lp-item-info .info-base {
  display: flex;
  align-items: center;
}

.lp-item-info .name {
  font-size: 16px;
  font-weight: 700;
}

.lp-item-info .icon {
  width: 12px;
  height: 12px;
  margin: 0;
  margin-left: 10px;
  font-size: 8px;
  font-weight: 700;
}

.lp-item-info .item-status {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 6px;
  font-size: 12px;
}

.lp-item-info .status1 {
  background: #fff7e8;
  color: #ff7d00;
}

.lp-item-info .status2 {
  background: #e8f3ff;
  color: #165dff;
}

.lp-item-info .status3 {
  background: #e8ffea;
  color: #00b42a;
}

.lp-item-info .status4 {
  background: #f2f3f5;
  color: #1d2129;
}

.lp-item-info .status5 {
  background: #ffece8;
  color: #f53f3f;
}

.lp-item-info .room {
  font-size: 12px;
  color: #999999;
}

.lp-item-info .time {
  margin-top: 4px;
  font-size: 12px;
  color: #999999;
}

.leave-status {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  color: #333333;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #999;
  margin-left: auto;
}
.arrow-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #999;
  margin-left: auto;
}

.leave-status::before {
  content: '';
  display: inline-block;
  width: 7px;
  height: 7px;
  border: 2px solid #029fd1;
  border-radius: 50%;
  margin-right: 5px;
  background: rgba(255, 255, 255, 0.3);
}

.leave-content {
  position: relative;
  padding: 10px 6px 6px 14px;
}

.leave-content-dotted::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 1px;
  background: linear-gradient(to bottom, transparent 0%, transparent 50%, #dadde1 50%, #dadde1 100%);
  background-size: 1px 8px;
  background-repeat: repeat-y;
  transform: translate(5px);
}

.leave-content .leave-item {
  display: flex;
  margin-bottom: 10px;
}

.leave-content .leave-name {
  flex-shrink: 0;
  width: 88px;
  font-size: 12px;
  color: #999999;
}

.leave-content .leave-value {
  font-size: 12px;
  color: #333333;
}

.lp-btn1 {
  float: right;
  width: 59px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border-radius: 4px;
  margin-left: 10px;
  background: #029fd1;
  font-size: 12px;
  color: #fff;
}

.lp-btn2 {
  float: right;
  width: 59px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border-radius: 4px;
  margin-left: 10px;
  background: #f3f3f3;
  font-size: 12px;
  color: #666666;
}

.lp-btn3 {
  float: right;
  width: 59px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border-radius: 4px;
  margin-left: 10px;
  background: #fff;
  font-size: 12px;
  color: #fff;
}

.form {
  padding: 20px;
}

.leave-status-btn {
  margin-top: 6px;
}

.pagination {
  width: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}
.el-button--primary {
  background: #029fd1;
  border-color: #029fd1;
}

.seach-header {
  display: flex;
  align-items: center;
}

.time-header {
  display: flex;
  align-items: center;
  margin-top: 8px;
  color: #999999;
}
.time-header .line {
  margin: 0 4px;
}

.lp-empty {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/leave/index.vue